module.exports = __webpack_public_path__ + "img/893c3fa.svg";